export default "__VITE_ASSET__Bf0l4fmU__"